import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SassDealSignup,
  SassDealSpeed,
  SassDealBoom,
} from "../../../app-constants";
import { Link } from "gatsby";

function Saasclosedeals() {
  return (
    <section className="saas_close_deals p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Why Tekrevol’s SaaS Video Production to{" "}
              <span>Close Deals Faster?</span>
            </h2>
            <p>
              Tekrevol has the team of the best techies, and highly versatile
              creatives who can help you to:
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="faster_deals_main">
              <div className="faster_item">
                <div className="faster_deal_head">
                  <h5>Catch quality leads from your landing page</h5>
                </div>
                <div className="faster_deal_img">{SassDealSignup}</div>
              </div>
              <p>
                Landing pages that feature an explainer get 86% more conversion.
                You can achieve the same. We’ll create software explainer videos
                that are customer-centric. These will work like sales pitch that
                arouse, educate, and inspire without doing the hard sell.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="faster_deals_main">
              <div className="faster_item">
                <div className="faster_deal_head">
                  <h5>Deliver SaaS value with blazing speed</h5>
                </div>
                <div className="faster_deal_img">{SassDealSpeed}</div>
              </div>
              <p>
                Your prospects only have so much time to read your SaaS guides.
                With our high-quality SaaS video production, we ensure that you
                can get your message across blazing fast.Your prospects will
                realize value in minutes!
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="faster_deals_main">
              <div className="faster_item">
                <div className="faster_deal_head">
                  <h5>Boom conversions of your SaaS product</h5>
                </div>
                <div className="faster_deal_img">{SassDealBoom}</div>
              </div>
              <p>
                Whether you want to raise awareness, nurture leads through a
                drip sequence, offer a FREE demo, or just spike conversions, we
                can help you achieve it all. There’s a SaaS explainer video for
                literally every stage of your marketing funnel. Let us tell your
                story, and witness your conversions skyrocket!
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Saasclosedeals;
